import React from 'react'

import styled from '@emotion/styled'
import Colors from 'utils/Colors'

import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector'

const StepIndicatorRoot = styled('div')(({ ownerState }) => ({
  backgroundColor: Colors.lightGray,
  zIndex: 1,
  color: '#fff',
  width: 80,
  height: 5,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  ...(ownerState.active && !ownerState.completed && {
    backgroundColor: Colors.googleYellow,
    // boxShadow: ' 0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundColor: Colors.green,
  }),
  ...(ownerState.error && {
    backgroundColor: Colors.red,
  }),
  ...(ownerState.completed &&
    ownerState.active && !ownerState.error && {
      backgroundColor: Colors.green,
    }),
}))

export const StepIndicator = (props) => {
  const { active, completed, error, className } = props

  return (
    <StepIndicatorRoot
      ownerState={{ completed: completed, active: active, error: error }}
      className={className}
    />
  )
}

export const Connector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 0,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: Colors.blue,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: Colors.green,
    },
  },
  [`&.${stepConnectorClasses.error}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: Colors.red,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 4,
    border: 0,
    width: 0,
    backgroundColor: Colors.googleYellow,
    borderRadius: 1,
  },
}))
